import { LuListTodo } from "react-icons/lu";

import { Button } from "@/components/ui/button/button";
import { Link, useParams } from "react-router-dom";
import { useCreateTodoModal } from "./create-todo-modal/use-create-todo-modal";
import { CreateTodoModal } from "./create-todo-modal";

export const EmployeeTodos = () => {
  const { empId } = useParams() as {
    empId: string;
  };

  const { onOpenChange } = useCreateTodoModal();

  return (
    <div className="w-60 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border p-3">
      <div className="flex flex-row items-center pb-2 justify-between">
        <h2 className="text-sm font-medium">Todos</h2>

        <LuListTodo className="w-3 h-3" />
      </div>
      <div className="justify-between flex items-center">
        <Button variant="default" size="sm" asChild>
          <Link to={`/admin/todos/employee-progress/${empId}`}>View</Link>
        </Button>

        <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            onOpenChange(true);
          }}
        >
          + Add
        </Button>
      </div>

      <CreateTodoModal />
    </div>
  );
};
